export const messages = {
    en: {
        index: {
            admin: {
                home: 'Home',
                platformData: 'Platform Data',
                housekeeping: 'Housekeeping',
                shop: 'Shop'
            },
            shopIndex: {
                todayData: 'Shop Data',
                shopVisitCount: 'Shop Visits (times)',
                waitShopOrderCount: 'Pending Orders (items)',
                returnOrderCount: 'Return Orders (items)',
                todayMoney: 'Transaction Amount (yuan)',
                hotProducts: 'Hot Products',
                userVisit: 'User Visits',
                productId: 'Product ID',
                productName: 'Product Name',
                productSpec: 'Product Specification',
                purchaseQuantity: 'Purchase Quantity'
              }
        }
    },
    zh: {
        index: {
            admin: {
                home: '首页',
                platformData: '平台数据',
                housekeeping: '家政销售',
                shop: '商品销售'
            },
            shopIndex: {
                todayData: '店铺数据',
                shopVisitCount: '店铺访问次数 (次)',
                waitShopOrderCount: '待处理订单 (件)',
                returnOrderCount: '退货订单 (件)',
                todayMoney: '成交金额 (元)',
                hotProducts: '热卖商品',
                userVisit: '用户访问',
                productId: '商品编号',
                productName: '商品名称',
                productSpec: '商品规格',
                purchaseQuantity: '购买数量'
              }
        }
    }
}